var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "emailQueue__container" }, [
    _vm.status == "processing"
      ? _c("div", [
          _c("div", { staticClass: "overlay" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-sending" }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.status == "sent"
      ? _c("div", { staticClass: "queue-sender" }, [_vm._m(0)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("p", [
          _c("a", { attrs: { href: "/admin/dashboard?s=firstRun" } }, [
            _vm._v("Siirry tästä backstagelle"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }